import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';

import type { ProgressData } from 'shared-types';

interface Props {
  completedLabel?: string;
  completionEnabled: boolean;
  emptyStyle?: React.CSSProperties;
  inProgressLabel?: string;
  notStartedLabel?: string;
  progressData: Pick<ProgressData, 'completed' | 'started' | 'participants'>;
  showInProgress?: boolean;
  showNotStarted?: boolean;
  style?: React.CSSProperties;
}

const ParticipantsStats = ({
  completedLabel,
  completionEnabled,
  emptyStyle,
  inProgressLabel,
  notStartedLabel,
  progressData,
  showInProgress = true,
  showNotStarted = true,
  style
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="stats" style={style}>
      {progressData.participants ? (
        <div className="progress">
          <ProgressBar
            labels={[
              ...(completionEnabled
                ? [
                    `${progressData.completed} ${
                      completedLabel || messages.tasksUsersCompletedSingular
                    }`
                  ]
                : []),
              ...(showInProgress
                ? [
                    `${progressData.started - progressData.completed} ` +
                      (inProgressLabel ||
                        (completionEnabled
                          ? messages.commonInProgress
                          : messages.tasksUsersStartedSingular))
                  ]
                : []),
              ...(showNotStarted
                ? [
                    `${progressData.participants - progressData.started} ` +
                      (notStartedLabel || messages.tasksUsersNotStartedSingular)
                  ]
                : [])
            ]}
            labelStyle={{ color: theme.textColorLight, marginBottom: 3 }}
            progresses={[
              {
                color: theme.successColor,
                progress: progressData.completed / progressData.participants
              },
              {
                color: 'rgba(0, 0, 0, 0.4)',
                progress: progressData.started / progressData.participants
              }
            ]}
          />
        </div>
      ) : (
        <div className="stat-empty" style={emptyStyle}>
          {messages.commonNoUsers}
        </div>
      )}

      <style jsx>{`
        .stats {
          display: inline-block;
          padding-top: 3px;
        }
        .stat-empty {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
          line-height: 1;
          position: relative;
          top: -3px;
        }
      `}</style>
    </div>
  );
};

export default ParticipantsStats;
